/**
 * Practice Org Review API (GDN-2271, GDN-2306).
 *
 * The provider-facing org-review endpoints ship in the generated
 * data-migration contract (`listOrgReviewPending` / `resolveOrgReviewRow` /
 * `matchOrgReviewRow`), so this file only layers cache-tag behaviour on top of
 * the generated api — mirroring `features/patient-import/store/api.ts`. A
 * successful resolve OR match invalidates the list tag, so the row leaves the
 * inbox on refetch when it commits, or reappears as a concrete conflict when a
 * match needs field resolution; the count-gated practice tab updates either way.
 */

import { enhancedApi as dataMigrationApi } from '@store/generated/data-migration';

export const orgReviewApi = dataMigrationApi.enhanceEndpoints({
  addTagTypes: ['OrgReviewList'],
  endpoints: {
    listOrgReviewPending: {
      providesTags: [{ type: 'OrgReviewList' as const, id: 'LIST' }],
    },
    resolveOrgReviewRow: {
      invalidatesTags: [{ type: 'OrgReviewList' as const, id: 'LIST' }],
    },
    matchOrgReviewRow: {
      invalidatesTags: [{ type: 'OrgReviewList' as const, id: 'LIST' }],
    },
  },
});

export const {
  useListOrgReviewPendingQuery,
  useResolveOrgReviewRowMutation,
  useMatchOrgReviewRowMutation,
} = orgReviewApi;
